// extracted by mini-css-extract-plugin
module.exports = {"CTA":"ChooseDesignerCTA_CTA___Psx_"};